.container
    margin: 4rem 1rem

.row
    display: flex
    align-items: flex-end
    gap: 2rem

    .select button
        padding: 0.65rem 2rem
